import { IFilePathList } from './FileUpload';

export enum EventTypes {
  FILEPATHS = 'FILEPATHS',
}

/**
 * THe FILEPATHS event payload
 */
export interface IFilePaths {
  filePaths: IFilePathList | null;
}

export type IUtilityReducer = IFilePaths;

export type IReducerPayload = IFilePaths | null;
